import getSvgIcon from '../services/Icons';
import { Component, h } from 'preact';
import { AttributesStore } from '../store/AttributesStore';
import manager from '../store/Attributes.manager';
import Items from './items/Items';

const ItemType = {
  Link: 1
};

const svgCloser = getSvgIcon('v');
const svgOpener = getSvgIcon('uf-logo');
const svgHideAllBtn = getSvgIcon('x');

export default class Fab extends Component {
  componentDidMount() {
    AttributesStore.subscribe(this.onStoreChange.bind(this))
  }

  onStoreChange(state) {
    const items = state.items.filter(ele => ele.isVisible).map(createAction);

    this.setState({
      badges: state.badges,
      channelsOpen: state.channelsOpen,
      flashcard: state.flashcard,
      hideAllBtn: !!state.hideAllBtn,
      isFrameOpened: state.isFrameOpened,
      isLoaderHidden: state.isLoaderHidden,
      items: items,
      logo: state.logo,
      noChannels: items.length === 0,
      title: state.title
    });
  }

  onmousemoveFab(event) {
    event.stopPropagation();

    if (this.timeout) {
      return;
    }

    manager.setItemsVisibility(true);

    this.timeout = setTimeout(this.closeChannels.bind(this), 2000);
  }

  hideFrame() {
    manager.setFrameVisivility(false);
  }

  closeChannels() {
    this.timeout = null;
    manager.setItemsVisibility(false);
  }

  onHideAllClick() {
    manager.hideAll();
  }

  render(props, state) {
    return (
      <div class="fab-wrapper">

        <div class={"fab-mobile " + generateFabClass(state)}>

          <Items items={state.items}
                 classname="fab-buttons-mobile"
                 isVisible={!state.isFrameOpened}
                 onItemClick={this.onItemClick}/>

          <div class="fab-action-button-mobile">
            <div class="tooltip-wrapper rounded"
                 onMouseMove={this.onmousemoveFab.bind(this)}>
              <div class="tooltip-wrapper__content">
                {state.title}
              </div>
            </div>

            {state.badges ?
              <div class="fab-action-button-mobile__favico">
                {state.badges}
              </div> : ''
            }

            {state.hideAllBtn ?
              <div class="fab-mobile__hide-all rounded"
                   onClick={this.onHideAllClick.bind(this)}
                   dangerouslySetInnerHTML={{ __html: svgHideAllBtn }}>
              </div> : null
            }
          </div>
        </div>

        <div class={"fab-desktop " + generateFabClass(state)}>
          <div class="fab-action-button">

            {state.badges ?
              <div class="fab-action-button__favico">
                {state.badges}
              </div> : ''
            }

            {state.hideAllBtn ?
              <div class="fab-action-button__hide-all"
                   onClick={this.onHideAllClick.bind(this)}
                   dangerouslySetInnerHTML={{ __html: svgHideAllBtn }}>
              </div> : null
            }

            <div onMouseMove={this.onmousemoveFab.bind(this)}>
              <img class={"fab-action-button__avatar " + ((!state.isFrameOpened && state.logo) ? "" : "hide")}
                   src={state.logo}/>

              <i class={"fab-action-button__opener " + ((!state.isFrameOpened && !state.logo) ? "" : "hide")}
                 dangerouslySetInnerHTML={{ __html: svgOpener }}/>
            </div>

            <i class={"fab-action-button__closer " + (state.isFrameOpened ? "" : "hide")}
               onClick={this.hideFrame}
               dangerouslySetInnerHTML={{ __html: svgCloser }}/>

          </div>

          <Items items={state.items}
                 isVisible={!state.isFrameOpened && !state.isLoaderHidden}
                 onItemClick={this.onItemClick}/>

          <div class="fab-action-button__tooltip">
            <div class="tooltip-wrapper"
                 onMouseMove={this.onmousemoveFab.bind(this)}>
              {state.title}
            </div>
          </div>
        </div>

      </div>
    )
  }
}

function onItemClick(channel, event) {
  event.stopPropagation();
  manager.goToChannel(channel);
}

function generateFabClass(state) {
  return (state.flashcard ? "flashcard " : "") +
    (state.channelsOpen ? "channels-open " : "") +
    (state.isFrameOpened ? "" : "visible ") +
    ((state.noChannels || state.isLoaderHidden) ? "no-channels" : "");
}

function createAction(action) {
  const isLink = action.type === ItemType.Link,
    href = isLink ? (action.href || '') : 'javascript:void(0);',
    name = isLink ? 'mail' : action.name,
    onclick = isLink ? undefined : onItemClick.bind(null, action.name),
    icon = action.icon || getSvgIcon(name),
    target = isLink ? (action.target || '_blank') : false;

  return {
    name,
    icon,
    tooltip: action.tooltip,
    isVisible: action.isVisible,
    order: action.order || 1,
    link: {
      href,
      onclick,
      target: target
    }
  };
}
